// extracted by mini-css-extract-plugin
export var container = "_ar-0";
export var containerTopRight = "_ar-1";